import { render, staticRenderFns } from "./ShowMoments.vue?vue&type=template&id=1b7e71ea"
import script from "./ShowMoments.vue?vue&type=script&lang=js"
export * from "./ShowMoments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports